<template>
	<v-card>
		<ContestUserTable :users="users" @refresh="refresh" :possibilities="possibilities"></ContestUserTable>
	</v-card>
</template>

<script>
	import ContestUserTable from "../contestUsers/components/ContestUserTable";
	import {PublicContest} from "../../../api/generated/PublicContest";

	export default {
		name: "ContestUsersListView",
		components: {ContestUserTable},

		data() {
			return {
				users: [],
				possibilities: [],
			};
		},

		mounted() {
			this.refresh();
		},

		methods: {
			sortBySurnameAsc (a, b) {
				return a.surname > b.surname ? 1 : b.surname > a.surname ? -1 : 0;
			},

			refresh() {
				PublicContest.getUsersAvailableToAdd(this, this.$route.params.id, successResponse => {
					this.possibilities = successResponse.sort(this.sortBySurnameAsc);
				});
				PublicContest.getUsers(this, this.$route.params.id, successResponse => {
					this.users = successResponse.sort(this.sortBySurnameAsc);
				});
			}
		},

	};

</script>

<style scoped>

</style>
